import { useRef } from 'react';
import type React from 'react';

// Pointer tracking for the auth pages (sign-in, sign-up, forgot password):
// the mouse position is written to CSS variables (--mx/--my in -1..1, --px/--py in px)
// that drive the card tilt and spotlight, so no re-render is needed.
export default function useCardTilt() {
  const containerRef = useRef<HTMLDivElement>(null);

  const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = containerRef.current;
    if (el === null) return;
    const x = e.clientX / window.innerWidth;
    const y = e.clientY / window.innerHeight;
    el.style.setProperty('--mx', String(x * 2 - 1));
    el.style.setProperty('--my', String(y * 2 - 1));
    el.style.setProperty('--px', `${e.clientX}px`);
    el.style.setProperty('--py', `${e.clientY}px`);
  };

  const onMouseLeave = () => {
    const el = containerRef.current;
    if (el === null) return;
    el.style.setProperty('--mx', '0');
    el.style.setProperty('--my', '0');
  };

  return { containerRef, onMouseMove, onMouseLeave };
}
